<template>


    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <div class="cf-dialog cf-dialog--xl">
                <div class="cf-modal-head cf-dialog-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-exchange-line"></i></span>
                        <div>
                            <h4 class="cf-dialog-title">{{titlemodal}}</h4>
                            <p class="cf-modal-head__sub">Transfert / opération de caisse</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                </div>
                <div class="cf-dialog-body">

                    <div class="box-body">
                        <div class="border-b-0 border-gray-200 dark:border-white/10">
                            <nav class="flex flex-wrap text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" aria-label="Tabs">
                                <button type="button" class="hs-tab-active:bg-white hs-tab-active:border-b-transparent
                                                hs-tab-active:text-primary dark:hs-tab-active:bg-transparent dark:hs-tab-active:border-b-white/10 dark:hs-tab-active:text-primary -mb-px py-2 px-3
                                                 inline-flex items-center gap-2 bg-gray-50 text-sm font-medium text-center border text-defaulttextcolor rounded-t-sm hover:text-primary
                                                 dark:bg-black/20 dark:border-white/10 dark:text-[#8c9097] dark:text-white/50 dark:hover:text-gray-300 active"
                                        id="hs-tab-js-behavior-item-1" data-hs-tab="#hs-tab-js-behavior-1" aria-controls="hs-tab-js-behavior-1">
                                    Information de base
                                </button>



                            </nav>
                        </div>

                        <div class="">
                            <div id="hs-tab-js-behavior-1" role="tabpanel" aria-labelledby="hs-tab-js-behavior-item-1" class="">


                                <div v-if="messagesucces!==''" class="mt-4 mb-4 alert alert-success !border-success/10 flex items-center" role="alert">

                                    <div v-html="messagesucces">

                                    </div>
                                </div>

                                <div v-if="messageerror!==''" class="mt-4 mb-4 alert alert-danger !border-danger/10 flex items-center" role="alert">

                                    <div v-html="messageerror">

                                    </div>
                                </div>


                                <div class="alert alert-info text-center mt-3">
                                    <p style="color: black;font-size: 15px;">Date : {{Items.datedoc}} </p>
                                </div>





                                <div class="ti-custom-validation mt-5" >
                                    <div  v-if="typedoc==='OPB' || typedoc==='BOR'"   class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">BANQUE :</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="banque"  >
                                                <option :value="null">Séléctionner une banque</option>
                                                <option v-for="(cp,inde) of alldata.cp" :key="inde" :value="cp">{{cp.name}}</option>
                                            </select>
                                        </div>

                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">TYPE D'OPERATION:</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="typoperation"  >
                                                <option value="DEBIT">DEBIT</option>
                                                <option value="CREDIT">CREDIT</option>
                                            </select>
                                        </div>


                                    </div>


                                    <div  v-if="typedoc==='BOR'"   class="grid lg:grid-cols-2 gap-6">


                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">CHARGE :</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="pcharge"  >
                                                <option :value="null">Séléctionner une charge</option>
                                                <option v-for="(ca,inde) of alldata.ca" :key="inde" :value="ca">{{ca.name}}</option>
                                            </select>
                                        </div>


                                        <div class="space-y-2 mt-5">
                                            <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">N°BORDEREAU</label>
                                            <input  v-model="numbordereau" type="text" class="form-control" >

                                        </div>

                                        <div class="space-y-2 mt-5">
                                            <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">NOM DU BENEFICIAIRE / DEPOSANT</label>
                                            <input  v-model="deposantname" type="text" class="form-control" >

                                        </div>

                                        <div class="space-y-2 mt-5">
                                            <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">N°CHEQUE</label>
                                            <input  v-model="numcheque" type="text" class="form-control" >

                                        </div>




                                    </div>

                                    <div  v-if="typedoc==='DPC' || typedoc==='APPROC'"   class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{titlecp}} :</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="Items.cp"  >
                                                <option :value="null">Séléctionner une Caisse principale</option>
                                                <option v-for="(cp,inde) of alldata.cp" :key="inde" :value="cp">{{cp.name}}</option>
                                            </select>
                                        </div>
                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{titleca}} :</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="Items.ca"  >
                                                <option :value="null">Séléctionner une Caisse auxilliaire</option>
                                                <option v-for="(ca,inde) of alldata.ca" :key="inde" :value="ca">{{ca.name}}</option>
                                            </select>
                                        </div>




                                    </div>


                                    <div  v-if="typedoc==='APPRO' || typedoc==='DPB'"   class="grid lg:grid-cols-2 gap-6">

                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{titlecp}} :</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="Items.cp"  >
                                                <option :value="null">Séléctionner une banque</option>
                                                <option v-for="(cp,inde) of alldata.cp" :key="inde" :value="cp">{{cp.name}}</option>
                                            </select>
                                        </div>
                                        <div class="space-y-2 mt-5">
                                            <label class="text-capitalize ti-form-label dark:text-defaulttextcolor/70 mb-0">{{titleca}} :</label>
                                            <select class="h-12 border border-gray-300 text-gray-600 text-base rounded-lg block w-full py-2.5 px-4 focus:outline-none" v-model="Items.ca"  >
                                                <option :value="null">Séléctionner une Caisse principale</option>
                                                <option v-for="(ca,inde) of alldata.ca" :key="inde" :value="ca">{{ca.name}}</option>
                                            </select>
                                        </div>




                                    </div>



                                    <div class="space-y-2 mt-5">
                                        <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">MOTIF / RAISON</label>

                                        <textarea v-model="Items.motif" class="form-control" cols="10" rows="4"></textarea>

                                    </div>




                                    <div class="space-y-2 mt-5">
                                        <label  class="text-capitalize ti-form-label
                                            dark:text-defaulttextcolor/70 mb-0">Montant</label>
                                        <input  v-model="Items.montant" type="number" class="form-control" >

                                    </div>




                                </div>
                            </div>



                        </div>
                    </div>




                </div>
                <div class="cf-dialog-foot">
                    <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                    <button v-if="typeaction==='add'" type="button" class="ti-btn ti-btn-primary-full" @click="saveItems">
                        <i class="ri-check-line align-middle"></i> Enregistrer
                    </button>
                    <button v-if="typeaction==='update'" type="button" class="ti-btn ti-btn-primary-full">
                        <i class="ri-edit-line align-middle"></i> Modifier
                    </button>
                </div>
            </div>
        </div>
    </Transition>

    <validationouinon ref="validationouinon" @aftervalidation="aftervalidation"></validationouinon>


</template>

<script>
    /*import templatesite from "@/components/template/apptemplate";
    import appheader from "@/components/template/appheader";
    import appsidebar from "@/components/template/appsidebar";
    import appmenu from "@/components/views/pages/definition/menu";*/
    // import allfunction from "@/allfunction";
    import {currencyFormatDE} from "@/allfunction";
    // import * as JwtService from "@/common/jwt.service";
    import validationouinon from "@/components/views/pages/caisse/transfertdefonddecaisse/validationouinon";


    //  const axios =require('axios');

    export default {
        /* eslint-disable */
        name: "modalform",
        watch: {


        },

        computed:{


            datamodereglement(){

                let mvalue=this.alldata.modedereglement;

                if (mvalue!==null){

                    if (this.Items.reglepar!==''){
                        let t=this;
                        mvalue = mvalue.filter( function (post) {
                            return    post.code.toLowerCase().includes(t.Items.reglepar.toLowerCase())
                        })

                    }



                }

                return mvalue

            },

            mtntrestantapayer(){
                let mvalue=0
                if (this.Items.avance!==null){
                    mvalue=parseInt(this.Items.mtntrestantapayertrt)-parseInt(this.Items.avance.montant)
                }
                else{
                    mvalue=parseInt(this.Items.mtntrestantapayertrt)

                }

                return mvalue;
            }


        },
        components: {


            validationouinon

        },

        data() {
            return {
                isdisplay:false,
                messageerror:"",
                messagesucces:"",
                classcaisse:"",
                checkvalue:false,
                titlemodal:"",
                alldata:{},
                typedoc:"",
                titleca:"",
                titlecp:"",
                vtypc:"",
                typereglement:'',
                authoriationplslignedepense:0,
                typeaction:"add",
                Items: {},

                name:'',
                typoperation:'DEBIT',
                banque:null,
                pcharge:null,
                numbordereau:"",
                deposantname:"",
                numcheque:"",
            };
        },
        methods: {

            formatMoney(value){
                return currencyFormatDE(value)

            },

            checkreglement(){
                this.Items.reglementbanque=null
                if (this.Items.reglepar==="Caisse"){

                    this.classcaisse="col-md-12 mt-2";
                    this.checkvalue=false;

                }else{

                    this.classcaisse="col-md-6 mt-2";
                    this.checkvalue=true;
                }


            },



            aftervalidation(elementSelectionne){

                /*this.Items.docnum=elementSelectionne.cnumdoc

                 let t=this;

                 if (t.typedoc==='DPCC' || t.typedoc==='REF'){
                     t.Items.alldepense.push({motif:t.Items.docobservation, montant:t.Items.montant});
                 }


                 let tabvalue={
                     numdoc:t.Items.docnum,
                     date:t.Items.datedoc,
                     montanttotal:t.Items.montant,
                     montanttotaldelafacure:t.Items.montant,
                     items:t.Items.alldepense,
                     docsaisiepar:t.$store.state.appusername,
                     benrficiaire:t.Items.beneficiaire.name,
                     qrr:t.Items.docnum,
                     patient:t.Items.beneficiaire.name,
                     observations:t.Items.docobservation,
                     typdoc:t.typedoc


                 }

                 this.$refs.modalrapportdeprefdpcc.show(tabvalue);*/


                this.close()



            },

            close(){

                this.isdisplay=false;

                this.$emit('closed');

            },

            show(titlemodal,typeaction,typedoc,Items,titleca,titlecp,vtypc,alldata){

                this.titlemodal=titlemodal
                this.typeaction=typeaction
                this.Items=Items
                this.typedoc=typedoc
                this.titleca=titleca
                this.titlecp=titlecp
                this.vtypc=vtypc
                this.alldata=alldata
                this.messagesucces="";
                this.messageerror="";

                this.typoperation='DEBIT';
                this.banque=null;
                this.pcharge=null;
                this.numbordereau="";
                this.deposantname="";
                this.numcheque="";

                this.isdisplay=true;

            },

            currencyFormatDE(p1){
                var number=Number(p1)
                return currencyFormatDE(number)
            },

            async  saveItems(){



                if(this.typedoc==='OPB' || this.typedoc==='BOR'){

                    if (this.banque===null ||
                        this.Items.motif==="" ||  this.Items.montant===0){

                        toastr['error']( 'Veuillez saisir toutes les informations',"<b></b>");
                        return ;

                    }

                    if (this.numbordereau==="" && this.typdoc==='BOR'){

                        toastr['error']( 'Veuillez saisir le numéreau de bordereau',"<b></b>");
                        return ;

                    }

                    if (this.deposantname==="" && this.typdoc==='BOR'){

                        toastr['error']( 'Veuillez saisir le nom du déposant / bénéficiaire',"<b></b>");
                        return ;

                    }

                    this.Items.cp=this.banque;
                    this.Items.pcharge=this.pcharge;
                    this.Items.numbordereau=this.numbordereau;
                    this.Items.deposantname=this.deposantname;
                    this.Items.numcheque=this.numcheque;
                    this.Items.typeoperation=this.typoperation;

                }

                else{

                    if (this.Items.ca===null || this.Items.cp===null ||
                        this.Items.motif==="" ||  this.Items.montant===0){

                        toastr['error']( 'Veuillez saisir toutes les informations',"<b></b>");
                        this.$store.dispatch('lancerchargement',false)
                        return ;

                    }

                }


                if (this.typedoc==="DPC"  || this.typedoc==="APPROC"  || this.typedoc==="DPB"){

                    if (parseFloat(this.$store.state.montantencaisse)<parseFloat(this.Items.montant) ){


                        toastr['error']( "Montant en caisse insuffisant pour effectuer l'opération. Montant en caisse :"+this.currencyFormatDE(this.$store.state.montantencaisse),"<b></b>");
                        this.$store.dispatch('lancerchargement',false)
                        return
                    }

                }







                let value={
                    'cf':this.$store.state.caisseinfo,
                    'item':this.Items,
                    'document':this.typedoc,
                }







                let titlemodal="";

                titlemodal=`

                      <h4>
                               Voulez-vous enregistrer cette opération de <span style="color: red;font-weight: bold;"> ${this.currencyFormatDE(this.Items.montant)} </span> ?

                      </h4>

                      `;



                this.$refs.validationouinon.show(titlemodal,value,this.typedoc);


            },

        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:94vh; overflow:hidden; }
.cf-dialog--xl { max-width:900px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }
.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }

    @media screen and (max-width: 768px) {

        .cf-dialog--xl{
            max-width: 100%!important;
        }


    }





</style>